import React from 'react';
import {FormattedMessage} from "react-intl";

import {sortOn} from "utils/sortOn";
import {toArray} from "./toArray";
import {NO_TRACKING_NUMBER} from "./getShipmentTrackingNumbers";

function getReturnShipments(shipments, returns) {
    let returnShipments = [];

    // new system: return is a new shipment, reached via order.returns[].shipments[]
    toArray(returns).forEach((returnRequest) => {
        toArray(returnRequest.shipments).forEach((shipment) => {
            returnShipments.push(shipment);
        });
    });

    // legacy system: return infos are in the current shipment
    toArray(shipments).forEach((shipment) => {
        if (shipment.returnTrackingNumber) {
            returnShipments.push(shipment);
        }
    });

    const uniqueIds = new Set();

    returnShipments = returnShipments.filter((returnShipment) => {
        if (!returnShipment.id) {
            return true;
        }

        if (uniqueIds.has(returnShipment.id)) {
            return false;
        }

        uniqueIds.add(returnShipment.id);

        return true;
    });

    return returnShipments.sort(sortOn('createdAt'));
}

function getReturnTrackingNumber(returnShipment) {
    // legacy system
    if (returnShipment.returnTrackingNumber && returnShipment.returnTrackingNumber !== NO_TRACKING_NUMBER) {
        return returnShipment.returnTrackingNumber;
    }

    // new system: any shipment reached via order.returns[] is inherently a return shipment
    if (returnShipment.trackingNumber && returnShipment.trackingNumber !== NO_TRACKING_NUMBER) {
        return returnShipment.trackingNumber;
    }

    return null;
}

// a shipment either has its own trackingNumber, or is split into parcels
// each carrying their own trackingNumber - never both
export function getReturnTrackingNumbers(shipments, returns) {
    return getReturnShipments(shipments, returns)
        .map((returnShipment) => ({
            trackingNumber: getReturnTrackingNumber(returnShipment),
            tooltip: <FormattedMessage id="oms.order.trackingNumbers.return" />
        }))
        .filter((item) => item.trackingNumber);
}
